import { ProductTokens } from '../types'
import { colors, PerthNowPalette } from './colors'

export const perthnow: ProductTokens<PerthNowPalette> = {
    colors,
}
